import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Interaction, CreateInteractionDTO } from '@/types';

export function useInteractions(candidateId: string | null) {
  return useQuery({
    queryKey: ['interactions', candidateId],
    queryFn: () => api.get<Interaction[]>(`/api/candidates/${candidateId}/interactions`),
    enabled: !!candidateId,
  });
}

export function useCreateInteraction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateInteractionDTO) => {
      const { candidate_id, ...body } = dto;
      return api.post<Interaction>(`/api/candidates/${candidate_id}/interactions`, body);
    },
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['interactions', variables.candidate_id] });
      qc.invalidateQueries({ queryKey: ['candidates', variables.candidate_id] });
      qc.invalidateQueries({ queryKey: ['candidates'] });
    },
  });
}
